import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetAllRegions, GetAllRegionsResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetAllRegionsResponse, GetAllRegionsResponse>) => response?.data?.regions
const getError = (response?: SWRResponse<GetAllRegionsResponse, GetAllRegionsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetAllRegionsResponse, GetAllRegionsResponse>) => ({});

const useGetAllRegions = (query?: Partial<GetAllRegions>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetAllRegions(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetAllRegions;